/**
 * AYUNEL 加购弹窗 · 行为层(Horizon 4.2 迁移)。2026-09-24 / 2026-10-03。
 *
 * 由 snippets/ayunel-cart-drawer-assets.liquid 以 <script type="module"> 引入(与官方 cart-drawer.js 同在抽屉开关之内)。
 * 沿用 9/24 自建行为层;4.2 购买可靠性补丁另在官方 assets 登记。本文件负责五件事(①–③ 2026-09-24 两路独立复审提出、逐条读官方源码 + 预览实测核实;④⑤ 智鹏 iPhone 实测提出):
 *
 * 前提:主题设置 cart_type 保持 page(右上角购物车图标照旧链接 /cart,智鹏 2026-09-24 定);弹窗由 snippets/cart-drawer.liquid
 * 改为非 /cart 页一律渲染,官方不会自动打开它 —— 打开只走这里的 ①。
 *
 * ① 加购【成功后】才弹。官方 auto-open(只在 cart_type=drawer 时有)在车不空时一发请求就开、失败也不关;这里不用它。
 *    官方 cart-drawer.js 在车不空时,加购请求一发出就开弹窗、失败(超库存 422 / 断网)也不关:
 *    手机上弹层盖住商品页「カートに追加」下方的失败提示,客人看着旧购物车以为已经加上。
 *    SOÉJU 同款:按钮转圈,成功后才弹。失败 → 不弹,失败提示留在原处。
 *    来源在打开着的模态弹窗里(尺码诊断等)→ 等那个弹窗关掉再开(照官方 cart-drawer.js 的处理,避免叠两层模态)。
 *    事件没带 promise(拿不到成败)→ 不弹。本主题三个加购入口(商品页 product-form / 2点セット / 收藏页)都带 promise
 *    且成败都 resolve 出 detail.didError(标准 CartLinesUpdateEvent 构造时就要求 promise)。
 *    回包没带弹窗这一段 sections(2点セット / 收藏页)→ 先按官方同口径重拉、换好内容再弹,不先弹一个旧车 / 空车
 *    (终审发现:否则约半秒内显示加购前的内容,旧行还可点、按行号改车)。重拉与官方 component-cart-items 的同一次重拉
 *    会被 sectionRenderer 按 section 合并;最多等 4 秒,超时照常弹(宁可晚一点刷新,也别让客人以为没加上)。
 *
 * ② 浏览器自己关弹窗(安卓返回键 / 返回手势 = close request)时补上官方的收尾。
 *    官方 theme-drawer.js 只拦了键盘 Esc(keydown preventDefault);dialog 被浏览器直接 close() 后,
 *    <theme-drawer open> 标记和整页滚动锁都留着 → 商品页滚不动、之后加购不再弹(预览模拟复现:overflow 仍 hidden)。
 *    cancel 能拦就拦下、改走官方 close()(有退场动画);拦不住(无用户激活时 cancel 不可取消)就在 close 事件里补调 close()
 *    —— 官方 #closeDialog 见 dialog 已关会跳过动画,只做解锁 / 清标记 / 还焦点。
 *    分辨「谁关的」靠两件事:官方 #closeDialog 先摘 open 标记再 dialog.close()(→ isOpen 为假,跳过);
 *    官方换形态(跨 990 宽的 #onModalBreakpointChange、#bringToFront、关闭动画中补开)是 close() 后立刻重开,
 *    close 事件到达时 dialog 已重新打开(→ dialog.open 为真,跳过;终审实测否则 iPad 转屏会把弹窗关掉)。
 *
 * ③ 页面从浏览器缓存恢复时,弹窗若还开着就关掉;内容重拉已交给 Horizon 4.2 原生 component-cart-items。
 *    场景:点「注文内容を確認する」去 /cart(普通链接,不先关弹窗)→ 在购物车页改了车 / 赠品被自动加进来 → 按返回。
 *    缓存里的商品页弹窗还开着、内容是旧车;弹窗里改数量 / 删除是按「第几行」下单的 → 可能改到另一件商品。
 *    ayunel.com 商品页 cache-control = private, max-age=0(不是 no-store)⇒ Safari / Chrome 都会走缓存恢复。
 *    Horizon 4.2 已补 persisted / back_forward 两通道重拉;这里不再重复重拉。
 *    (页头件数归官方 cart-icon.js:它只在「最后一次改车不到 10 秒」时才在 pageshow 修正 —— 整页购物车时代就是这样,本脚本不接手。)
 *
 * ④ 点弹窗外面就关(SOÉJU 同款;智鹏 2026-09-24 iPhone 实测「只能点叉关」)。
 *    官方靠点 ::backdrop(isClickedOutside)关,Chrome 能关、iPhone Safari 不关 —— 点暗底会不会送到 dialog 取决于浏览器。
 *    手机(<750)改成弹窗本体铺满整屏、上方 96px 透明(样式在 ayunel-cart-drawer-assets),点的是 dialog 自己 → 这里关。
 *    判据 = 点击目标就是弹窗面板 dialog 本身、且落点不在白色内层里;弹窗里还开着别的小弹窗时不关(同官方)。
 *
 * ⑤ 弹窗里滑动只滚弹窗里真能滚的区域(智鹏 2026-09-24 iPhone 实测「弹窗里一滑,后面页面整个跟着滑」;
 *    第一版只按「在不在商品列表那一大块里」放行,顶部免运费块 / 底部合計也在那一块里但本身滚不动 → iPhone 把滑动传给了整页,二测仍动)。
 *    现判据 = 手指下往上找「竖向滚得动、且这个方向还没到头」的区域,找不到就拦 —— 到头时也拦,不靠 overscroll-behavior
 *    (那条样式照留作双保险)。横向手势、双指缩放不拦;触摸监听只在弹窗打开期间挂着(关时摘掉,不拖慢全站滚动)。
 *
 * 只认弹窗面板本身(<theme-drawer id="cart-drawer"> 的直接子 dialog):弹窗里可能嵌着官方的小 dialog
 * (商品「開示」说明 cart-disclosure-modal),它的 cancel / close / click 不许被当成整个弹窗(终审发现)。
 *    ≥750 仍是官方抽屉 + ::backdrop,官方与这里都会调 close(),第二次被官方 #isClosing 挡掉,不会重复。
 *
 * 守卫:tests/test_theme_cart_drawer.py(静态契约);交互:预览真浏览器走查(见 08-themes/newhouse-20260827/HANDOFF-20260924-加购弹窗.md)。
 */
import { StandardEvents } from '@shopify/events';
import { sectionRenderer } from '@theme/section-renderer';

const DRAWER_ID = 'cart-drawer';
const SECTION_ID = 'cart-drawer-section';

/** @returns {HTMLElement & {isOpen: boolean, open: () => void, close: () => Promise<void>} | null} */
const cartDrawer = () => /** @type {any} */ (document.getElementById(DRAWER_ID));

/** 事件目标是不是购物车弹窗的面板 dialog 本身(cancel / close 都不冒泡,在捕获阶段接;嵌套的小 dialog 不算) */
const drawerOfDialog = (target) =>
  target instanceof HTMLDialogElement && target.parentElement?.id === DRAWER_ID
    ? /** @type {any} */ (target.parentElement)
    : null;

const REFETCH_WAIT_MS = 4000;

/** 按官方 component-cart-items 对抽屉的口径重拉弹窗内容(hydration、不用缓存、空车时补装样式) */
const refetchDrawer = (drawer) =>
  sectionRenderer.renderSection(SECTION_ID, {
    cache: false,
    mode: 'hydration',
    injectStylesheet: drawer.querySelector('[data-cart-drawer-empty]') !== null,
  });

/**
 * 从手指下的元素往上找(找到弹窗为止):有没有一个竖向能滚、且这次滑动方向还没滚到头的区域。
 * dy > 0 = 手指往下拖 = 内容往上回滚;dy < 0 = 手指往上推 = 内容往下滚。
 * 只看「真的滚得动」:overflow-y 是 auto/scroll 且内容高于可视高度 —— 顶部免运费块、底部合計虽然在内容区里,
 * 但内容区本身滚不动(吸底模式下滚的是商品列表),所以它们下面找不到可滚区域 → 拦掉(智鹏 2026-09-24 iPhone 实测)。
 */
function canScrollInDirection(target, boundary, dy) {
  for (let el = target; el && el !== boundary; el = el.parentElement) {
    const overflowY = getComputedStyle(el).overflowY;
    if ((overflowY === 'auto' || overflowY === 'scroll') && el.scrollHeight > el.clientHeight + 1) {
      if (dy > 0 && el.scrollTop > 0) return true;
      if (dy < 0 && el.scrollTop + el.clientHeight < el.scrollHeight - 1) return true;
      if (dy === 0) return true;
      // 这一层在这个方向已到头:继续往外找(外层也可能还能滚)
    }
  }
  return false;
}

if (!window.__aynCartDrawerBound) {
  window.__aynCartDrawerBound = true;

  // ① 加购成功后才弹
  document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
    if (event.action !== 'add' || !event.promise) return;
    const sourceModal = event.target instanceof Element ? event.target.closest('dialog:modal') : null;

    event.promise
      .then(async (result) => {
        // AYUNEL OVERRIDE 2026-10-03: POST succeeded but cart GET failed; product form shows a confirmed-add /cart link.
        // Do not open an old drawer over that message or invite a second add.
        if (result?.detail?.didError || result?.detail?.cartRefreshFailed) return;
        const drawer = cartDrawer();
        if (!drawer) return;
        if (!result?.detail?.sections?.[SECTION_ID]) {
          // 2点セット / 收藏页:回包不带弹窗内容 → 先换好再弹(失败或超时也照常弹)
          await Promise.race([
            refetchDrawer(drawer).catch(() => {}),
            new Promise((resolve) => setTimeout(resolve, REFETCH_WAIT_MS)),
          ]);
        }
        const openDrawer = () => {
          if (!drawer.isOpen) drawer.open();
        };
        if (sourceModal instanceof HTMLDialogElement && sourceModal.open) {
          sourceModal.addEventListener('close', openDrawer, { once: true });
        } else {
          openDrawer();
        }
      })
      .catch(() => {
        // 加购被中止 / 出错:不弹(失败提示由各入口自己显示)
      });
  });

  // ② 浏览器直接关弹窗:能拦就改走官方 close(),拦不住就补收尾
  document.addEventListener(
    'cancel',
    (event) => {
      const drawer = drawerOfDialog(event.target);
      if (!drawer || !drawer.isOpen) return;
      event.preventDefault();
      drawer.close();
    },
    true
  );

  document.addEventListener(
    'close',
    (event) => {
      const drawer = drawerOfDialog(event.target);
      // dialog 已被官方重新打开(换形态 / 补开)= 不是浏览器替客人关的,跳过
      if (drawer?.isOpen && !event.target.open) drawer.close();
    },
    true
  );

  // ④ 点弹窗外面(手机:上方透明那截)就关 —— SOÉJU 同款
  document.addEventListener(
    'click',
    (event) => {
      const drawer = drawerOfDialog(event.target);
      if (!drawer?.isOpen) return;
      const dialog = /** @type {HTMLDialogElement} */ (event.target);
      if (dialog.querySelector('dialog[open]')) return; // 弹窗里还开着别的小弹窗时不关(同官方 #hasOpenNestedDialog)
      const inner = dialog.querySelector('.cart-drawer__inner');
      if (inner) {
        const r = inner.getBoundingClientRect();
        const inside =
          event.clientX >= r.left && event.clientX <= r.right && event.clientY >= r.top && event.clientY <= r.bottom;
        if (inside) return;
      }
      drawer.close();
    },
    true
  );

  // ⑤ 弹窗开着时:手指下面没有「这个方向还能滚」的区域 → 这一下滑动拦掉(不让滚动穿透到后面的商品页)
  //    只在弹窗打开期间挂(终审:常驻的 passive:false 触摸监听会让全站手机起滑都先等主线程);开 / 关跟官方
  //    theme-drawer:open / theme-drawer:close 事件走(冒泡,target = <theme-drawer id="cart-drawer">)。
  let lastX = 0;
  let lastY = 0;
  const onDrawerTouchStart = (event) => {
    if (event.touches.length !== 1) return;
    lastX = event.touches[0].clientX;
    lastY = event.touches[0].clientY;
  };
  const onDrawerTouchMove = (event) => {
    const drawer = cartDrawer();
    if (!drawer?.isOpen) return;
    if (event.touches.length !== 1) return; // 双指缩放不管(放大看字是无障碍需要)
    const target = event.target instanceof Element ? event.target : null;
    if (!target || !drawer.contains(target)) return;

    const { clientX: x, clientY: y } = event.touches[0];
    const dx = x - lastX;
    const dy = y - lastY;
    lastX = x;
    lastY = y;
    if (Math.abs(dx) > Math.abs(dy)) return; // 横向手势不管(弹窗里没有横滑,也不拦别人的)

    if (!canScrollInDirection(target, drawer, dy) && event.cancelable) event.preventDefault();
  };
  const TOUCHSTART_OPTS = { capture: true, passive: true };
  const TOUCHMOVE_OPTS = { capture: true, passive: false };

  document.addEventListener('theme-drawer:open', (event) => {
    if (event.target?.id !== DRAWER_ID) return;
    // 同一函数 + 同 capture 重复添加会被浏览器去重(官方 #bringToFront 会再发一次 open)
    document.addEventListener('touchstart', onDrawerTouchStart, TOUCHSTART_OPTS);
    document.addEventListener('touchmove', onDrawerTouchMove, TOUCHMOVE_OPTS);
  });

  document.addEventListener('theme-drawer:close', (event) => {
    if (event.target?.id !== DRAWER_ID) return;
    document.removeEventListener('touchstart', onDrawerTouchStart, { capture: true });
    document.removeEventListener('touchmove', onDrawerTouchMove, { capture: true });
  });

  // AYUNEL OVERRIDE 2026-10-03: Horizon 4.2 component-cart-items owns refresh on persisted / back_forward.
  // Keep only AYUNEL's close/unlock responsibility here; a second render would abort the native restore.
  window.addEventListener('pageshow', (event) => {
    const navigation = globalThis.performance?.getEntriesByType?.('navigation')[0];
    if (!event.persisted && navigation?.type !== 'back_forward') return;
    const drawer = cartDrawer();
    if (drawer?.isOpen) drawer.close();
  });
}
